export const iconFontAwesomeUsersPeopleUserPen = (
	<i className="fa-solid fa-user-pen"></i>
);
